import styled from "styled-components";
import { Colors } from "../../values/colors";

export const PageBody = styled.div`
  padding: 1.25rem 1.5rem;
`;

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 1.5rem;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCard = styled.div`
  background: #F6F6F6;
  border-radius: 10px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
`;

export const StatIconCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: ${Colors.secondaryPurple};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const StatInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const StatLabel = styled.span`
  font-size: 12px;
  color: ${Colors.blueMist};
  font-weight: 500;
`;

export const StatValue = styled.span`
  font-size: 26px;
  font-weight: 700;
  color: ${Colors.secondaryPurple};
  line-height: 1;
`;

export const FiltersBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 8px;
  padding: 8px 14px;
  flex: 1;
  min-width: 180px;
  background: ${Colors.white};

  &:focus-within {
    border-color: ${Colors.primary};
  }
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 14px;
  color: ${Colors.blueGray};
  width: 100%;
  background: transparent;

  &::placeholder {
    color: ${Colors.lightGray};
  }
`;

export const SearchBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${Colors.primaryPurple};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

export const FilterLabel = styled.span`
  font-size: 13px;
  color: ${Colors.blueMist};
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const FilterSelect = styled.select`
  border: 1px solid ${Colors.secondaryPurple};
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 13px;
  color: ${Colors.secondaryPurple};
  background: ${Colors.white};
  cursor: pointer;
  outline: none;

  &:focus {
    border-color: ${Colors.primary};
  }
`;

export const SectionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 20px 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: ${Colors.primaryColor};
`;

export const SectionDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ color }) => color || Colors.primaryPurple};
  display: inline-block;
`;

export const SectionCount = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${Colors.blueMist};
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`;

export const ActionCard = styled.div`
  background: #fff;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 10px;
  padding: 0px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
`;

export const CardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CardTitleDesc = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const GraduationIcon = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${Colors.primaryPurple};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

export const PriorityBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 180px;
  background: ${({ bg }) => bg};
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 14px;
  border-radius: 0px 0px 10px 10px;
  white-space: nowrap;
`;

export const CardTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  margin: 0;
  line-height: 1.4;
`;

export const CardCategory = styled.span`
  font-size: 12px;
  color: ${Colors.blueMist};
`;

export const CardDescription = styled.p`
  font-size: 13px;
  color: ${Colors.blueGray};
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: ${Colors.blueMist};
`;

export const CardDivider = styled.hr`
  border: none;
  border-top: 1px solid ${Colors.ultraLightGray};
  margin: 0;
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PracticedBtn = styled.button`
  flex: 1;
  padding: 8px 10px;
  border-radius: 6px;
  border: 2.5px ${({ $active }) => ($active ? "solid" : "dashed")} 
    ${({ $active }) => ($active ? Colors.secondaryGreen : Colors.ultraLightGray)};
  background: ${({ $active }) => ($active ? Colors.secondaryGreen : 'transparent')};
  color: ${({ $active }) => ($active ? '#fff' : Colors.blueGray)};
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: ${Colors.secondaryGreen};
    color: ${({ $active }) => ($active ? '#fff' : Colors.blueGray)};
    background: ${({ $active }) => ($active ? Colors.secondaryGreen : 'rgba(45,206,159,0.08)')};
  }
`;


export const TrackBtn = styled.button`
  flex: 1;
  padding: 8px 10px;
  border-radius: 6px;
  background: transparent;
  color: ${Colors.primaryPurple};
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: ${Colors.primaryPurple};
    background: rgba(93,61,237,0.06);
  }
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: ${({ variant }) => variant === "danger" ? Colors.red : Colors.blueGray};
  cursor: pointer;

  &:hover {
    background: ${Colors.ultraLightGray2};
  }
`;

export const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  gap: 12px;
  text-align: center;
`;

export const EmptyIconCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(93, 61, 237, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
`;

export const EmptyTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: ${Colors.primaryPurple};
  margin: 0;
`;

export const EmptySubtext = styled.p`
  font-size: 14px;
  color: ${Colors.blueMist};
  max-width: 380px;
  margin: 0;
  line-height: 1.6;
`;
